import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataResult, DataSourceRequestState } from '@progress/kendo-data-query';
import { BehaviorSubject } from 'rxjs';
import { AppConstant } from 'src/app/app.constant';
import { IdNameModel } from '../../attendance/attendance.classes';
import { EditIdNameModel } from 'src/app/_metronic/core/classes/core.class';

@Injectable()
export class ClassService {
    apiUrl: string;
    kendoDataUrl: string;

    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
        this.kendoDataUrl = this.apiUrl + 'GetAll';
    }

    getClassDetailForGird(state: DataSourceRequestState, customFilters: any): Observable<DataResult> {
        let params = {
            state: state,
            customFilters: customFilters
        }
        return this.httpClient.post(`${this.apiUrl}/getAllClass/`, params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    async getClassDetail() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllClassName/`).toPromise()).data;
    }
    async getAllClassNameList() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllClassNameList/`).toPromise()).data;
    }

    getClassById(classId: number) {
        return this.httpClient.get(`${this.apiUrl}/getClassById/` + classId).pipe(
            map((response: any) => {
                return response.data
            })
        )
    }
    getClassDetailExcel(state: DataSourceRequestState, customFilters: any) {
        let params = {
            state: state,
            customFilters: customFilters
        }
        return new Promise((resolve, reject) => {
            this.httpClient.post(`${this.apiUrl}/getAllClass/`, params).pipe(
                map(res => res))
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }

    manageClass(classData) {
        return this.httpClient.post(`${this.apiUrl}/manageClass/`, classData).pipe(
            map((response: any) => {
                return response;
            }))
    }
    classBulkCreate(classData) {
        return this.httpClient.post(`${this.apiUrl}/bulkImportClass/`, classData).pipe(
            map((response: any) => {
                return response;
            }))
    }
    deleteMultipleClass(classIdNameList: Array<EditIdNameModel> = []) {
        return this.httpClient.post(`${this.apiUrl}/bulkDeleteClass/`, {
            DataToDelete: classIdNameList
        }).pipe(
            map((response: any) => {
                return response;
            }))
    }
}